import { DEFAULT_MAX_COUNT } from './Counter.constants'

export function getCounterValue(count, fixed, maxCount = DEFAULT_MAX_COUNT) {
  return fixed ? `+${count}` : maxCount < count ? `${maxCount}+` : count
}
